import config from 'config';
import { http_client } from './api';

const getList = async (start = null, end = null, user_id = null) => {
  return http_client
    .get(
      config.apiUrl +
        'schedule?' +
        `${start ? 'start=' + start : ''}` +
        `${end ? '&end=' + end : ''}` +
        `${user_id ? '&user_id=' + user_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (year = null, month = null, user_id = null) => {
  return http_client
    .get(
      config.apiUrl +
        'schedule/archive?' +
        `${year ? 'year=' + year : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${user_id ? '&user_id=' + user_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListDaily = async (date = null, user_id = null) => {
  return http_client.get(config.apiUrl + 'schedule/daily?' + `${date ? 'date=' + date : ''}` + `${user_id ? '&user_id=' + user_id : ''}`)
    .then((response) => {
      return response.data;
    });
};

const getListSemester = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/semester' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListWeekly = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  // Add cache busting timestamp
  params.append('_t', Date.now());
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/weekly' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListTahunan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/tahunan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListBulanan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/bulanan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListMingguan = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/mingguan' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const getListHarian = async (jenjang = null, cabang = null) => {
  const params = new URLSearchParams();
  if (jenjang && Array.isArray(jenjang) && jenjang.length > 0) {
    jenjang.forEach((id) => {
      params.append('jenjang[]', id);
    });
  } else if (jenjang) {
    params.append('jenjang', jenjang);
  }
  if (cabang) {
    params.append('cabang', cabang);
  }
  const queryString = params.toString();
  const url = config.apiUrl + 'schedule/harian' + (queryString ? '?' + queryString : '');
  return http_client
    .get(url)
    .then((response) => {
      return response.data;
    });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'schedule/' + id).then((response) => {
    return response.data;
  });
};

const getStudentWeeklyCount = async (studentId, classScheduleId) => {
  return http_client
    .get(config.apiUrl + `schedule/student-weekly-count?student_id=${studentId}&class_schedule_id=${classScheduleId}`)
    .then((response) => {
      return response.data;
    });
};

const exportAllSchedules = async () => {
  try {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const year = today.getFullYear().toString();

    const response = await http_client.getFile(config.apiUrl + 'schedule/export-all');

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `jadwal-semua-${day}-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting all schedules:', error);
  }
};

const ScheduleService = {
  getList,
  getListArchive,
  getListDaily,
  read,
  getStudentWeeklyCount,
  getListSemester,
  getListWeekly,
  getListTahunan,
  getListBulanan,
  getListMingguan,
  getListHarian,
  exportAllSchedules
};

export default ScheduleService;

